document.addEventListener("DOMContentLoaded", () => {
  // Home page or featured collection product select size
  document
    .querySelectorAll(".product-item__quick-buy")
    .forEach(function (quickBuyElement) {
      const variantSelect = quickBuyElement.querySelector(
        "select.product-variant__container"
      );
      const form = quickBuyElement.querySelector("form");
      const productVariants = quickBuyElement.querySelector("product-variants");
      const submitButton = form?.querySelector('button[type="submit"]');
      const submitButtonInner =
        submitButton?.querySelector("span.button__text");

      // Ensure required elements exist before proceeding
      if (!form || !submitButton || !submitButtonInner) {
        console.error("Missing required elements in quick buy section.");
        return;
      }

      if (variantSelect && variantSelect.options.length > 1) {
        // Multiple variants available
        submitButtonInner.innerText = "Select Size";
        submitButton.classList.add("has_many_variant");

        form.addEventListener("submit", function () {
          setTimeout(() => {
            submitButtonInner.innerText = "Select Size";
            submitButton.disabled = true;
            submitButton.classList.add("disabled");
            variantSelect.selectedIndex = 0;
            variantSelect.dispatchEvent(new Event("change"));
            if (productVariants) {
              productVariants.style.zIndex = 100;
            }
          }, 500);
        });

        variantSelect.addEventListener("change", function () {
          if (variantSelect.selectedIndex !== 0) {
            submitButtonInner.innerText = "Add to Cart";
            submitButton.disabled = false;
            submitButton.classList.remove("disabled");
            if (productVariants) {
              productVariants.style.zIndex = 0;
            }
          }
        });
      } else {
        // Single variant or no select dropdown
        if (variantSelect) {
          variantSelect.remove(); // Remove dropdown if only one option exists
        }
        submitButtonInner.innerText = "Add to Cart";
        submitButton.disabled = false;
        submitButton.classList.remove("disabled");

        // Handle any additional styling if needed
        if (productVariants) {
          productVariants.style.zIndex = 0; // Ensure proper zIndex
        }
      }
    });

  // product page sub product select size
  let interval = setInterval(function () {
    document
      .querySelectorAll(".product-item-compact__form")
      .forEach(function (quickBuyElement) {
        const variantSelect = quickBuyElement.querySelector(
          "select.product-variant__container"
        );
        if (variantSelect && variantSelect.options.length > 1) {
          const form = quickBuyElement.querySelector("form");
          const submitButton = form.querySelector('button[type="submit"]');
          const submitButtonInner = form.querySelector(
            'button[type="submit"] span.button__text'
          );
          submitButtonInner.innerText = "Select Size";

          form.addEventListener("submit", function () {
            setTimeout(() => {
              submitButtonInner.innerText = "Select Size";
              submitButton.disabled = true;
              submitButton.classList.add("disabled");
              variantSelect.selectedIndex = 0;
              variantSelect.dispatchEvent(new Event("change"));
            }, 500);
          });
          variantSelect.addEventListener("change", function () {
            if (variantSelect.selectedIndex !== 0) {
              submitButtonInner.innerText = "Add to Cart";
              submitButton.disabled = false;
              submitButton.classList.remove("disabled");
            }
          });
        } else if (variantSelect && variantSelect.options.length == 1) {
          const form = quickBuyElement.querySelector("form");
          const submitButton = form.querySelector('button[type="submit"]');
          const submitButtonInner = form.querySelector(
            'button[type="submit"] span.button__text'
          );
          variantSelect.remove();
          submitButtonInner.innerText = "Add to Cart";
          submitButton.disabled = false;
          submitButton.classList.remove("disabled");
        }
      });
    clearInterval(interval);
  }, 2000);

  const notsubmitButtons = document.querySelectorAll(
    'button[type="submit"].not_avlbl'
  );

  notsubmitButtons.forEach((button) => {
    const buttonText = button.querySelector("span.button__text");
    if (buttonText) {
      buttonText.innerText = "Sold Out";
    }
    button.disabled = true;
    button.classList.add("disabled");
  });

  // iframe open triggered
  document.querySelectorAll(".load_iframe_click").forEach((element) => {
    element.addEventListener("click", function (event) {
      if (
        document.querySelector(".load_iframe_click") &&
        document.querySelector("#load_iframe")
      ) {
        event.preventDefault();
        document.querySelector("#load_iframe").click();
        document
          .querySelectorAll("main#main .shopify-section")
          .forEach((section) => {
            if (!section.querySelector(".show-iframe")) {
              section.style.display = "none";
            }
          });
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
  });

  // add to cart sticky after it scrolls in mobile
  document.addEventListener("scroll", function () {
    const mainpdp = document.querySelector("product-page");
    const stickybtn = document.querySelector(".btn_with_offers");
    if (mainpdp && stickybtn) {
      const sectionTop = mainpdp.offsetTop;
      const scrollTop = window.scrollY;

      if (scrollTop >= sectionTop) {
        stickybtn.classList.add("fixed");
      } else {
        stickybtn.classList.remove("fixed");
      }
    }
  });

  // make the section navbar sticky after it scrolls
  const section = document.querySelector(".ctmpd_nav");
  const stickyElement = document.querySelector(".ctmpd__top");

  let lastScrollTop = 0; // Store last scroll position
  const offset = 80; // Offset before it becomes sticky

  if (section && stickyElement) {
    document.addEventListener("scroll", function () {
      const sectionBottom = section.offsetTop + section.offsetHeight - offset;
      const scrollTop = window.scrollY;

      if (scrollTop > lastScrollTop && scrollTop >= sectionBottom) {
        // Scrolling down and section is fully out of view (before top 20px)
        stickyElement.classList.add("fixed");
      } else if (scrollTop < lastScrollTop && scrollTop < sectionBottom) {
        // Scrolling up and section is visible again
        stickyElement.classList.remove("fixed");
      }

      if (stickyElement.classList.contains("fixed")) {
        if (scrollTop < lastScrollTop) {
          stickyElement.classList.add("scrolling-up");
        } else {
          stickyElement.classList.remove("scrolling-up");
        }
      }

      lastScrollTop = scrollTop; // Update last scroll position
    });
  }

  // toggle offer section
  const offerTitle = document.querySelector(".main__offers_title");
  const offerMain = document.querySelector(".main__offers_main");

  if (offerTitle && offerMain) {
    offerTitle.addEventListener("click", function () {
      this.classList.toggle("active");
      offerMain.classList.toggle("active");
    });
  }

  // add active class on sroll
  const links = document.querySelectorAll(".ctmpd__top a");
  const sections = Array.from(links).map((link) =>
    document.querySelector(link.getAttribute("href"))
  );
  const topNav = document.querySelector(".ctmpd__top");

  links.forEach((link, index) => {
    if (!sections[index]) {
      link.style.display = "none";
    }
  });

  if (links.length && sections.length) {
    function onScroll() {
      let scrollPosition = window.scrollY;

      sections.forEach((section, index) => {
        if (section) {
          const sectionTop = section.offsetTop - 50; // Adjust offset if needed
          const sectionBottom = sectionTop + section.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            updateActiveLink(index);
          }
        }
      });
    }

    function updateActiveLink(activeIndex) {
      links.forEach((link, index) => {
        if (index === activeIndex) {
          link.classList.add("active");

          // Manually scroll `.ctmpd__top` to keep the active link visible
          const linkOffset =
            link.offsetLeft - topNav.offsetWidth / 2 + link.offsetWidth / 2;
          topNav.scrollTo({ left: linkOffset, behavior: "smooth" });
        } else {
          link.classList.remove("active");
        }
      });
    }

    function smoothScrollTo(targetY, duration = 600) {
      const startY = window.scrollY;
      const distance = targetY - startY;
      const startTime = performance.now();

      function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      }

      function animate(currentTime) {
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        const easing = easeInOutQuad(progress);

        window.scrollTo(0, startY + distance * easing);

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      }

      requestAnimationFrame(animate);
    }

    links.forEach((link, index) => {
      link.addEventListener("click", function (event) {
        event.preventDefault();

        const targetSection = sections[index];
        if (targetSection) {
          const targetPosition =
            targetSection.getBoundingClientRect().top + window.scrollY - 20;
          smoothScrollTo(targetPosition, 600);
        }
        updateActiveLink(index);
      });
    });

    window.addEventListener("scroll", onScroll);
  }

  // product page model open
  let openButtons = document.querySelectorAll(".ctm_model_open");

  if (openButtons.length > 0) {
    openButtons.forEach((button) => {
      button.addEventListener("click", function () {
        let popupId = this.getAttribute("id");
        let popup = document.querySelector(
          `.ctm_model[data-popup='${popupId}']`
        );
        let bgoverlay = document.querySelector(".ctm_model__bg");
        let closeButton = popup.querySelector(".ctm_model__close");

        if (popup) {
          popup.classList.add("active");
          bgoverlay.classList.add("active");
          document.documentElement.classList.add("overflow-hidden");
          document.body.classList.add("overflow-hidden", "hide__header");

          if (window.innerWidth < 768) {
            let contentDivs = popup.querySelectorAll(
              ".ctm_model__txt .ctm_rdmr"
            );
            contentDivs.forEach((content) => {
              let existingButton =
                content.parentNode.querySelector(".toggle-btn");
              if (!existingButton) {
                // Ensure button is not duplicated
                let linesToShow = 8;
                let isExpanded = false;
                content.style.webkitLineClamp = linesToShow;
                content.style.display = "-webkit-box";
                content.style.webkitBoxOrient = "vertical";
                content.style.overflow = "hidden";
                content.style.transition = "max-height 0.3s ease";
                if (content.scrollHeight > linesToShow * 20) {
                  let toggleBtn = document.createElement("button");
                  toggleBtn.className = "toggle-btn read-more-btn vw_more";
                  toggleBtn.innerHTML = `<span>View More</span>`;
                  content.parentNode.appendChild(toggleBtn);
                  toggleBtn.addEventListener("click", function () {
                    if (isExpanded) {
                      content.style.webkitLineClamp = linesToShow;
                      toggleBtn.innerHTML = `<span>View More</span>`;
                      toggleBtn.classList.add("vw_more");
                      popup.classList.remove("view_more_opened");
                    } else {
                      content.style.webkitLineClamp = "unset";
                      toggleBtn.innerHTML = `<span>View Less</span>`;
                      toggleBtn.classList.remove("vw_more");
                      popup.classList.add("view_more_opened");
                    }
                    isExpanded = !isExpanded;
                  });
                }
              }
            });
          }

          let closePopup = () => {
            let modelToggleBtn = popup.querySelector(".toggle-btn");
            popup.classList.remove("active", "view_more_opened");
            bgoverlay.classList.remove("active");
            document.body.classList.remove("overflow-hidden", "hide__header");
            document.documentElement.classList.remove("overflow-hidden");
            if (modelToggleBtn) modelToggleBtn.remove();
          };

          closeButton.addEventListener("click", closePopup);
          bgoverlay.addEventListener("click", closePopup);
        }
      });
    });
  }

  // View-more in mobile pdp
  if (window.innerWidth < 768) {
    let contentDivs = document.querySelectorAll(".ctm_rdmr");
    if (contentDivs) {
      contentDivs.forEach((content) => {
        let linesToShow = 8;
        let isExpanded = false;
        content.style.webkitLineClamp = linesToShow;
        content.style.display = "-webkit-box";
        content.style.webkitBoxOrient = "vertical";
        content.style.overflow = "hidden";
        content.style.transition = "max-height 0.3s ease";
        if (content.scrollHeight > linesToShow * 20) {
          let toggleBtn = document.createElement("button");
          toggleBtn.className = "toggle-btn read-more-btn vw_more";
          toggleBtn.innerHTML = `<span>View More</span>`;
          content.parentNode.appendChild(toggleBtn);
          toggleBtn.addEventListener("click", function () {
            if (isExpanded) {
              content.style.webkitLineClamp = linesToShow;
              toggleBtn.innerHTML = `<span>View More</span>`;
              toggleBtn.classList.add("vw_more");
            } else {
              content.style.webkitLineClamp = "unset";
              toggleBtn.innerHTML = `<span>View Less</span>`;
              toggleBtn.classList.remove("vw_more");
            }
            isExpanded = !isExpanded;
          });
        }
      });
    }
  }
});
